import client from './client';

// Mutual-aid surfaces that are not about one specific fire.

// Everyone who could have turned up: other FPAs (including shadow ones, which
// exist precisely so their assistance can be recorded) plus the organisation
// register, flattened into one list keyed on a stable provider key.
//
// Pass the FIRE's tenant id, not the current user's. A super admin has no
// meaningful "own FPA", so keying self-exclusion off the caller would offer
// Roodeplaat as its own assistant while editing a Roodeplaat fire. Response:
//   { providers: [{ key, kind, id, name, org_type, stations, is_shadow }], total }
export const listAidProviders = (tenantId) =>
  client
    .get('/aid/providers', { params: tenantId ? { tenant_id: tenantId } : {} })
    .then((r) => r.data);

// The reciprocal view: fires belonging to OTHER FPAs that this FPA turned out
// to. Served from purpose-written receipt rows, not from the fires themselves
// — an FPA cannot read another FPA's reports — so the payload is deliberately
// narrow: when, roughly where, how big, and what we contributed. No internal
// notes, no member identity, no coordinates.
//
// A normal user may only read their own FPA; naming someone else 403s.
export const listAidProvided = (params) =>
  client.get('/aid/provided', { params }).then((r) => r.data);
